import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {numberFormat} from "@pg-mono/string-utils";

import {ApplicationModalButtonWithHiddenPrices} from "../../../application/components/ApplicationModalButtonWithHiddenPrices";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {Country} from "../../../region/types/Country";
import {useAppSelector} from "../../../store/hooks";
import {getCurrency} from "../../../utils/get_currency";
import {IOfferDetail} from "../../types/IOfferDetail";
import {OfferPriceType} from "../../types/OfferPriceType";
import {getOfferDisplayStatus} from "../../utils/get_offer_display_status";

interface IProps {
    offer: IOfferDetail;
}

export function OfferDetailHeaderPriceButtonVariantBCD(props: IProps) {
    const {offer} = props;

    const lowestPropertyPrice = useAppSelector((state) => state.offerDetail.lowestPriceProperty)?.price || null;
    const shouldShowPrice = useShouldShowPrice({
        vendorId: offer.vendor.id
    });

    const offerRangePrice = (offer.region.country === Country.SPAIN && offer?.stats?.ranges_price_min) || offer.stats?.ranges_price_m2_min || null;
    const priceType = offer.price_type === OfferPriceType.NETTO ? " netto" : offer.price_type === OfferPriceType.BRUTTO ? " brutto" : "";

    const applicationButtonText = getLeadButtonText({
        isProperty: false,
        isPriceHidden: !shouldShowPrice
    });

    const gtmProps = {
        clickText: applicationButtonText,
        source: GTMEventApplicationSourceSection.HEADER_LEAD,
        vendorName: offer.vendor.name ?? offer.vendor.id.toString(),
        offerName: offer.name ?? offer.id.toString()
    };

    return (
        <>
            {!lowestPropertyPrice && offerRangePrice ? (
                <ApplicationModalButtonWithHiddenPrices
                    source={ApplicationSource.OfferPriceInquiry}
                    sourceSection={ApplicationSourceSection.HEADER}
                    vendorId={offer.vendor.id}
                    offerId={offer.id}
                    propertyId={null}
                    forceClose={getOfferDisplayStatus(offer) === "limited"}
                    shouldShowPrice={shouldShowPrice}
                    gtmData={gtmProps}
                    render={({handleClick}) => (
                        <Button onClick={handleClick} variant="filled_primary" size="medium" css={[w100]} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            Ceny od:{" "}
                            <span className="bt">
                                {`${numberFormat(offerRangePrice)} ${getCurrency({currency: offer.currency})}${priceType}`}
                                {offer.region.country === Country.SPAIN && offer.stats?.ranges_price_min ? null : (
                                    <>
                                        /m<sup>2</sup>
                                    </>
                                )}
                            </span>
                        </Button>
                    )}
                />
            ) : (
                <ApplicationModalButtonWithHiddenPrices
                    source={ApplicationSource.OfferPriceInquiry}
                    sourceSection={ApplicationSourceSection.HEADER}
                    vendorId={offer.vendor.id}
                    offerId={offer.id}
                    propertyId={null}
                    forceClose={getOfferDisplayStatus(offer) === "limited"}
                    shouldShowPrice={shouldShowPrice}
                    gtmData={gtmProps}
                    render={({handleClick}) => (
                        <Button onClick={handleClick} variant="filled_primary" css={[w100]} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            {applicationButtonText}
                        </Button>
                    )}
                />
            )}
        </>
    );
}
import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {numberFormat} from "@pg-mono/string-utils";

import {ApplicationModalButtonWithHiddenPrices} from "../../../application/components/ApplicationModalButtonWithHiddenPrices";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {Country} from "../../../region/types/Country";
import {useAppSelector} from "../../../store/hooks";
import {getCurrency} from "../../../utils/get_currency";
import {IOfferDetail} from "../../types/IOfferDetail";
import {OfferPriceType} from "../../types/OfferPriceType";
import {getOfferDisplayStatus} from "../../utils/get_offer_display_status";

interface IProps {
    offer: IOfferDetail;
}

export function OfferDetailHeaderPriceButtonVariantBCD(props: IProps) {
    const {offer} = props;

    const lowestPropertyPrice = useAppSelector((state) => state.offerDetail.lowestPriceProperty)?.price || null;
    const shouldShowPrice = useShouldShowPrice({
        vendorId: offer.vendor.id
    });

    const offerRangePrice = (offer.region.country === Country.SPAIN && offer?.stats?.ranges_price_min) || offer.stats?.ranges_price_m2_min || null;
    const priceType = offer.price_type === OfferPriceType.NETTO ? " netto" : offer.price_type === OfferPriceType.BRUTTO ? " brutto" : "";

    const applicationButtonText = getLeadButtonText({
        isProperty: false,
        isPriceHidden: !shouldShowPrice
    });

    const gtmProps = {
        clickText: applicationButtonText,
        source: GTMEventApplicationSourceSection.HEADER_LEAD,
        vendorName: offer.vendor.name ?? offer.vendor.id.toString(),
        offerName: offer.name ?? offer.id.toString()
    };

    return (
        <>
            {!lowestPropertyPrice && offerRangePrice ? (
                <ApplicationModalButtonWithHiddenPrices
                    source={ApplicationSource.OfferPriceInquiry}
                    sourceSection={ApplicationSourceSection.HEADER}
                    vendorId={offer.vendor.id}
                    offerId={offer.id}
                    propertyId={null}
                    forceClose={getOfferDisplayStatus(offer) === "limited"}
                    shouldShowPrice={shouldShowPrice}
                    gtmData={gtmProps}
                    render={({handleClick}) => (
                        <Button onClick={handleClick} variant="filled_primary" size="medium" css={[w100]} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            Ceny od:{" "}
                            <span className="bt">
                                {`${numberFormat(offerRangePrice)} ${getCurrency({currency: offer.currency})}${priceType}`}
                                {offer.region.country === Country.SPAIN && offer.stats?.ranges_price_min ? null : (
                                    <>
                                        /m<sup>2</sup>
                                    </>
                                )}
                            </span>
                        </Button>
                    )}
                />
            ) : (
                <ApplicationModalButtonWithHiddenPrices
                    source={ApplicationSource.OfferPriceInquiry}
                    sourceSection={ApplicationSourceSection.HEADER}
                    vendorId={offer.vendor.id}
                    offerId={offer.id}
                    propertyId={null}
                    forceClose={getOfferDisplayStatus(offer) === "limited"}
                    shouldShowPrice={shouldShowPrice}
                    gtmData={gtmProps}
                    render={({handleClick}) => (
                        <Button onClick={handleClick} variant="filled_primary" css={[w100]} dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}>
                            {applicationButtonText}
                        </Button>
                    )}
                />
            )}
        </>
    );
}
